/**
 * @generated SignedSource<<85d5c248d3539cb86c49ef278b651440>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignsCarousel_iconicDesignsDirectoryPage$data = {
  readonly bannerImages: ReadonlyArray<{
    readonly imageUrl: string | null;
  } | null> | null;
  readonly description: string | null;
  readonly " $fragmentType": "DesignsCarousel_iconicDesignsDirectoryPage";
};
export type DesignsCarousel_iconicDesignsDirectoryPage$key = {
  readonly " $data"?: DesignsCarousel_iconicDesignsDirectoryPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignsCarousel_iconicDesignsDirectoryPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignsCarousel_iconicDesignsDirectoryPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignBannerImageUrl",
      "kind": "LinkedField",
      "name": "bannerImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignsDirectoryPage",
  "abstractKey": null
};

(node as any).hash = "3fe97191bf237f5bcd1116454ff2e558";

export default node;
